
import RbConditionalContent from './conditional-content.vue'
export default {
  name: 'rb-conditional-content-wrapper',
  extends: RbConditionalContent,
}
